<template>
  <div :class="styles.col">
    <div :class="{ active }" class="term-box h-100">
      <slot name="savings"></slot>
      <span class="pt-3 pb-2 text-semibold" v-if="this.term_type === 'Month'">{{ $t('common.monthly') }}</span>
      <span class="pt-3 pb-2 text-semibold" v-if="this.term_type === 'Year'">{{ $t('common.annually') }}</span>
      <span class="pt-3 pb-2 text-semibold" v-if="this.term_type === 'Years'">{{ terms }} {{ $t('common.years', ['this.term_type']) }}</span>
      <slot name="text"></slot>
      <slot name="monthly-price"></slot>
      <slot name="firstyear"></slot>
      <slot name="reccomended" v-if="this.terms === this.default_recommended_terms && this.term_type === 'Years'"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailedSelectBox',

  props: {
    active: {
      type: Boolean,
      default: false
    },
    terms: {
      type: Number,
      required: true
    },
    term_type: {
      type: String,
      required: true
    },
    default_recommended_terms: {
      type: Number,
      default: 2
    },
    styles: {
      type: Object,
      default() {
        return {
          col: 'colpb-xs-1 term-col'
        };
      }
    }
  }
};
</script>
